module.exports = __webpack_public_path__ + "static/img/image (2).24a0cb12.png";